import { Link, useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import AlunoPreMatriculadoCard from './AlunoPreMatriculadoCard';

import axios from 'axios';
import { API_HOST } from 'consts';
import Card from 'components/Card';

const ListaAlunosPreMatriculadosPage = ({ cards, ...rest }) => {
  const { id } = useParams();
  const [alunos, setAlunos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAlunos = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${API_HOST}/academico/status_confirmacao/${id}/pre_matriculados`
        );
        setAlunos(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error('Erro ao buscar pré-matriculados', error);
        setAlunos([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAlunos();
  }, [id]);
  return (
    <Card title="Alunos Pré-Matriculados na Turma">
      <div className="mb-3" />
      <Link to={`/turma/${id}/detalhes`}>
        <div>
          <p>
            Detalhes da Turma
          </p>
        </div>
      </Link>
      {loading && (
        <div>
          <p>Carregando Estudantes</p>
        </div>
      )}
      {!loading && alunos.length === 0 && (
        <div>
          <p>Não há alunos pré-matriculados na turma.</p>
        </div>
      )}
      {alunos &&
        alunos.map((aluno) => {
          return (
            <AlunoPreMatriculadoCard
              key={aluno.id}
              usuario={aluno}
              curriculum={aluno.curriculum}
            />
          );
        })}
      </Card>
  );
};
export default ListaAlunosPreMatriculadosPage;
